import { render } from "./Tabs.vue?vue&type=template&id=84237af6"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jamieplamb/Dropbox/Jamie - Documents/TotalParkingSolutions/Apps/TPSWhitelister/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__